class Togglers {
  constructor(options) {
    var defaults = {};
    this.params = Object.assign({}, defaults, options || {});
    this.togglers = document.querySelectorAll('.toggler');
    this.blocks = document.querySelectorAll('.toggler-block');
    this.scroll = 0;
    this.setupTogglers();
  }
  setupTogglers() {
    var blocks = this.blocks;
    this.togglers.forEach((toggler) => {
      toggler.addEventListener('click', function(event) {
        event.preventDefault();
        var el = this;
        var target = el.dataset.open;
        blocks.forEach((div) => {
          if (window.pageYOffset) {
            this.scroll = window.pageYOffset;
          }
          let id = div.getAttribute('id');
          if (id === target) {
            document.documentElement.classList.toggle(id + '-opened');
          }
          if (this.scroll) {
            window.scroll(0, this.scroll);
          }
        });
      });
    });
  }
}

export {
  Togglers as
  default
};
